import React from 'react';
import { Platform } from 'react-native';
export default function DateTimePicker() {
  React.useEffect(function () {
    console.warn("DateTimePicker is not supported on: ".concat(Platform.OS));
  }, []);
  return null;
}